import { render, staticRenderFns } from "./MJSliderButton.vue?vue&type=template&id=c1b3887c&scoped=true&"
import script from "./MJSliderButton.vue?vue&type=script&lang=js&"
export * from "./MJSliderButton.vue?vue&type=script&lang=js&"
import style0 from "./MJSliderButton.vue?vue&type=style&index=0&id=c1b3887c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1b3887c",
  null
  
)

export default component.exports